// extracted by mini-css-extract-plugin
export const headBgColorExternal = "#ffffff";
export const headBgColorInternal = "#1c2234";
export const headBgColorShrunkSidebar = "#3c425a";
export const regular = "400";
export const medium = "500";
export const semibold = "600";
export const bold = "700";
export const sans = "'sans'";
export const serif = "'serif'";
export const atlasGrotesk = "'AtlasGrotesk'";
export const textCenter = "ExpandButton__textCenter__C5z3M";
export const expandButton = "ExpandButton__expandButton__QAH-x";
export const iconWrapper = "ExpandButton__iconWrapper__XX66H";
export const expanded = "ExpandButton__expanded__jbnXU";